<template>
  <v-app-bar app dark class="asta-nav">
    <v-app-bar-nav-icon @click="toggleDrawer">
      <!-- <v-btn
        v-if="!user_uid || !asta_squadre[user_uid]"
        fab
        small
        depressed
        text
        class="navy darken-1 white--text"
        @click.stop="callLoginPanel"
      >
        <v-icon>account_circle</v-icon>
      </v-btn> -->

      <v-btn fab small depressed text>
        <!-- <squadra-crediti :id="user_uid" xSmall></squadra-crediti> -->
        <v-icon>menu</v-icon>
      </v-btn>
    </v-app-bar-nav-icon>

    <!-- <v-btn
      fab
      x-small
      text
      class="white--text ml-2"
      @click="promptSblocco"
      v-if="!premium && user_uid && asta_squadre[user_uid]"
    >
      <v-icon>workspace_premium</v-icon>
    </v-btn>
    <v-btn fab x-small text class="ml-2" v-else> </v-btn> -->

    <!-- <dialog-iframe url="https://www.google.com"></dialog-iframe>
    <v-btn fab x-small text class="ml-2" @click="test">test </v-btn> -->

    <v-spacer></v-spacer>

    <div
      class="d-flex flex-column align-self-start align-center"
      :style="{ marginTop: !is_mobile ? '5px' : '0px' }"
    >
      <!-- modalita -->
      <div class="text-center mb-1">
        <v-btn
          rounded
          small
          text
          class="gradient-green"
          @click="promptImpostazioni"
        >
          <v-icon x-small left>settings</v-icon>
          {{ asta_mode_name }}
          <v-icon small right>expand_more</v-icon>
        </v-btn>
      </div>
      <div class="d-flex justify-center align-center">
        <!-- sync -->
        <v-btn
          fab
          x-small
          depressed
          class="navy darken-2 white--text mr-1 con-ombra"
          v-if="!Config.STANDALONE"
          @click="checkAllineamentoRose(true)"
          ><v-icon small>sync</v-icon>
        </v-btn>
        <!-- semaforo -->
        <semaforo mode="bar"></semaforo>
        <!-- salva -->
        <v-btn
          fab
          x-small
          depressed
          v-if="!Config.STANDALONE"
          class="navy darken-2 white--text ml-1 con-ombra"
          @click="promptSaveRose"
          ><v-icon>save</v-icon>
        </v-btn>
        <!-- <v-btn
          fab
          x-small
          depressed
          v-else
          class="navy darken-2 white--text ml-1 con-ombra"
          @click="promptDownloadRose"
          ><v-icon>download</v-icon>
        </v-btn> -->
      </div>
    </div>

    <v-spacer></v-spacer>

    <!-- help -->
    <!-- <v-btn
      fab
      x-small
      text
      class="white--text mr-2"
      @click="promptComeFunziona"
    >
      <v-icon>info</v-icon>
    </v-btn> -->
    <!-- layout -->
    <v-speed-dial v-model="fab_aspect" direction="bottom" class="speeddial">
      <!-- activator dello speed-dial -->
      <template v-slot:activator>
        <v-btn fab x-small text depressed class="white--text">
          <v-icon small v-if="fab_aspect">close</v-icon>
          <div v-else>
            <v-icon class="mr-n1" small v-if="useSound"> volume_up </v-icon>
            <v-icon class="mr-n1" small v-else> volume_off </v-icon>
            <v-icon class="ml-n1" small> more_vert </v-icon>
          </div>
        </v-btn>
      </template>
      <!-- sound -->
      <v-btn-toggle dense rounded borderless v-model="soundModel" mandatory>
        <v-btn :class="bgSpeedDial" :value="0" @click.stop>
          <v-icon :class="colorSpeedDial" small>volume_off</v-icon>
        </v-btn>
        <v-btn :class="bgSpeedDial" :value="1" @click.stop>
          <v-icon :class="colorSpeedDial" small>volume_up</v-icon>
        </v-btn>
      </v-btn-toggle>

      <!-- orientation -->
      <!-- <v-btn-toggle
        dense
        rounded
        borderless
        v-model="squadreOrientationModel"
        mandatory
      >
        <v-btn
          :class="bgSpeedDial"
          :value="Constants.SQUADRE_ORIENTATION.VERTICAL"
          @click.stop
        >
          <v-icon :class="colorSpeedDial">crop_portrait</v-icon>
        </v-btn>
        <v-btn
          :class="bgSpeedDial"
          :value="Constants.SQUADRE_ORIENTATION.HORIZONTAL"
          @click.stop
        >
          <v-icon :class="colorSpeedDial">crop_16_9</v-icon>
        </v-btn>
      </v-btn-toggle> -->

      <!-- tavoloLayout -->
      <v-btn-toggle
        dense
        rounded
        borderless
        v-model="tavoloLayoutModel"
        mandatory
      >
        <v-btn
          :class="bgSpeedDial"
          :value="Constants.TAVOLO_LAYOUT.CERCHIO"
          @click.stop
        >
          <v-icon :class="colorSpeedDial" small>lens</v-icon>
        </v-btn>
        <v-btn
          :class="bgSpeedDial"
          :value="Constants.TAVOLO_LAYOUT.GRIGLIA"
          @click.stop
        >
          <v-icon :class="colorSpeedDial">view_module</v-icon>
        </v-btn>
      </v-btn-toggle>

      <!-- tavoloSize -->
      <v-btn-toggle
        v-show="tavoloLayoutModel == Constants.TAVOLO_LAYOUT.CERCHIO"
        dense
        rounded
        borderless
        class="icone-cerchi"
        v-model="tavoloSizeModel"
        mandatory
      >
        <v-btn
          :class="bgSpeedDial"
          :value="Constants.TAVOLO_SIZE.SMALL"
          @click.stop
        >
          <v-icon :class="colorSpeedDial">lens</v-icon>
        </v-btn>
        <v-btn
          :class="bgSpeedDial"
          :value="Constants.TAVOLO_SIZE.MEDIUM"
          @click.stop
        >
          <v-icon :class="colorSpeedDial">lens</v-icon>
        </v-btn>
        <v-btn
          :class="bgSpeedDial"
          :value="Constants.TAVOLO_SIZE.LARGE"
          @click.stop
        >
          <v-icon :class="colorSpeedDial">lens</v-icon>
        </v-btn>
      </v-btn-toggle>
      <!-- squadreSize -->
      <v-btn-toggle
        dense
        rounded
        borderless
        class="icone-cerchi"
        v-model="squadreSizeModel"
        mandatory
      >
        <v-btn
          :class="bgSpeedDial"
          :value="Constants.SQUADRE_SIZE.SMALL"
          @click.stop
        >
          <v-icon :class="colorSpeedDial">account_box</v-icon>
        </v-btn>
        <v-btn
          :class="bgSpeedDial"
          :value="Constants.SQUADRE_SIZE.MEDIUM"
          @click.stop
        >
          <v-icon :class="colorSpeedDial">account_box</v-icon>
        </v-btn>
        <v-btn
          :class="bgSpeedDial"
          :value="Constants.SQUADRE_SIZE.LARGE"
          @click.stop
        >
          <v-icon :class="colorSpeedDial">account_box</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-speed-dial>

    <!-- <v-btn
      v-if="Config.STANDALONE && !asta_info.isMine"
      @click="addToMyAste"
      icon
      light
      depressed
    >
      <v-icon>book</v-icon>
    </v-btn> -->

    <!-- <v-dialog eager v-model="dialog" content-class="dialog__halfWidth">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon depressed small class="white--text">
          <v-icon>share</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class=" headline" style="width: 100%">
          <span class="white--text">Condividi</span>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="white--text"
            light
            icon
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title> -->
    <!-- <v-card-text>
          Fai sapere subito ai tuoi amici che hai trovato questo fantastico tool
          per gestire le aste in tempo reale
          <social-sharing
            url="https://www.fantapazz.com/fantacalcio/tutorials/asta-live"
            inline-template
          >
            <v-row row wrap>
              <v-col xs12 text-center>
                <network network="facebook">
                  <v-btn text>
                    <v-icon left fa>facebook</v-icon>
                    Facebook
                  </v-btn>
                </network>
              </v-col>
              <v-col xs12 class="text-center">
                <network network="twitter">
                  <v-btn text>
                    <v-icon left fa>twitter</v-icon>
                    Twitter
                  </v-btn>
                </network>
              </v-col>
              <v-col xs12 class="text-center">
                <network network="googleplus">
                  <v-btn text>
                    <v-icon left fa>google-plus</v-icon>
                    Google +
                  </v-btn>
                </network>
              </v-col>
              <v-col xs12 class="text-center">
                <network network="whatsapp">
                  <v-btn text>
                    <v-icon left fa>whatsapp</v-icon>
                    Whatsapp
                  </v-btn>
                </network>
              </v-col>
            </v-row>
          </social-sharing>
        </v-card-text> -->
    <!-- </v-card>
    </v-dialog> -->
  </v-app-bar>
</template>

<script>
// require("font-awesome/css/font-awesome.css");
import db from "../js/db";
import mixins from "../js/mixins";
import SquadraCrediti from "./common/SquadraCrediti";
import Semaforo from "./common/Semaforo";
// import DialogIframe from "./common/DialogIframe";
import Constants from "../js/constants";
import Vuex from "vuex";

export default {
  name: "asta-nav",
  mixins: [mixins],
  components: {
    SquadraCrediti,
    Semaforo,
    // DialogIframe,
  },
  mounted() {
    console.log("--> AstaNav ready.");
    // db.on("campetto-rettangolare", () => {
    //   this.tavoloLayoutModel = Constants.TAVOLO_LAYOUT.GRIGLIA;
    // });
  },
  destroyed() {
    console.log("<-- AstaNav destroyed.");
  },
  data() {
    return {
      dialog: false,
      fab_aspect: false,
    };
  },

  methods: {
    // test() {
    //   db.emit("show-dialog-iframe", "www.google.com");
    // },
    goHome: function () {
      this.$router.push("/");
    },
    promptImpostazioni() {
      db.emit("showImpostazioni");
    },
    promptSblocco() {
      db.emit("showSblocco");
    },
    promptComeFunziona() {
      db.emit("showComeFunziona");
    },
    toggleUseSound() {
      this.$store.dispatch("setUseSound", !this.useSound);
    },
    // showUserPanel: function () {
    //   Swal.fire({
    //     title: this.asta_squadre[this.user_uid].name,
    //     html:
    //       '<img class="picture" src="' +
    //       this.asta_squadre[this.user_uid].pic +
    //       '"/>',
    //     confirmButtonColor: "#009688",
    //   });
    // },
    callLoginPanel: function () {

      Swal.fire({
        title: "Ciao " + this.user_displayName,
        html: "Solo i presidenti delle squadre possono partecipare all'asta. I co-gestori e gli ospiti non possono parteciparvi ma possono seguirla.",
        icon: "warning",
        confirmButtonColor: "#009688",
        cancelButtonColor: "#BDBDBD",
      });
    },
    // addToMyAste() {
    //   db.addAsta();
    // },
    toggleDrawer() {
      db.emit("toggleDrawer");
    },
    sharePanel() {
      Swal.fire({
        title: "Condividi",
        html:
          '<social-sharing url="https://vuejs.org/" inline-template>\n' +
          "  <div>\n" +
          '      <network network="facebook">\n' +
          '        <i class="fa fa-facebook"></i> Facebook\n' +
          "      </network></div></social-sharing>",
      });
    },
  },
  computed: {
    ...Vuex.mapGetters([
      "useSound",
      "tavoloLayout",
      "tavoloSize",
      "squadreSize",
      "squadreOrientation",
      "is_mobile",
      "user_displayName"
    ]),
    bgSpeedDial() {
      return this.is_mobile ? "navy darken-1" : "navy darken-2";
    },
    colorSpeedDial() {
      return this.is_mobile ? "white--text" : "white--text";
    },
    soundModel: {
      get() {
        return this.useSound;
      },
      set(value) {
        this.$store.dispatch("setUseSound", value);
      },
    },
    squadreOrientationModel: {
      get() {
        return this.squadreOrientation;
      },
      set(value) {
        this.$store.dispatch("setSquadreOrientation", value);
      },
    },
    tavoloLayoutModel: {
      get() {
        return this.tavoloLayout;
      },
      set(value) {
        // check
        if (value == Constants.TAVOLO_LAYOUT.CERCHIO) {
          let nSquadre = _.size(this.asta_squadre);
          let limit = Constants.LIMIT_SQUADRE_LAYOUT_CERCHIO;
          if (nSquadre > limit) {
            Swal.fire({
              icon: "info",
              title: "Suggerimento",
              text:
                "In leghe con più di " +
                limit +
                ' squadre è preferibile la visualizzazione a "griglia" e non a "tavolo rotondo" per evitare sovrapposizioni',
              confirmButtonText: "Ok, ho capito",
            });
          }
        }
        this.$store.dispatch("setTavoloLayout", value);
        if (value == Constants.TAVOLO_LAYOUT.CERCHIO) {
          this.$store.dispatch("setSquadreSize", Constants.SQUADRE_SIZE.SMALL);
        }
      },
    },
    tavoloSizeModel: {
      get() {
        return this.tavoloSize;
      },
      set(value) {
        this.$store.dispatch("setTavoloSize", value);
      },
    },
    squadreSizeModel: {
      get() {
        return this.squadreSize;
      },
      set(value) {
        this.$store.dispatch("setSquadreSize", value);
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.asta-nav {
  background-color: #233a45 !important;
  box-shadow: 0px 1px 0 0 #1f343f !important;
}
.speeddial {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .v-btn-toggle {
    margin: 0 0px 6px 0;
    flex-direction: row-reverse;
    background: transparent;

    > .v-btn.v-btn:first-child {
      border-top-right-radius: inherit;
      border-bottom-right-radius: inherit;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    > .v-btn.v-btn:last-child {
      border-top-left-radius: inherit;
      border-bottom-left-radius: inherit;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .v-btn {
      margin: 0;
      opacity: 1;
      background: var(--v-navy-base);
      &.v-item--active {
        color: transparent;
        background: var(--v-accent-base) !important;
      }
    }
    &.icone-cerchi {
      .v-btn {
        &:first-child i {
          font-size: 12px;
        }

        i {
          font-size: 20px;
        }

        &:last-child i {
          font-size: 28px;
        }
      }
    }
  }
}
</style>
